export const teams = [
  {
    id: 0, name: 'Finance', color: '#8d6e92', icon: 'globe',
  }, {
    id: 1, name: 'Marketing', color: '#ee9183', icon: 'dollar-sign',
  }, {
    id: 2, name: 'Sales', color: '#d1aa53', icon: 'sack-dollar',
  },
];

export const users = [
  {
    id: 1,
    firstName: 'Rashid',
    lastName: 'Abdallah',
    imageUrl: './assets/img/avatars/03.png',
    email: 'rabdallah@gmail.com',
    phone: '(123) 456-7890',
    userType: 1, // ['user', 'Admin'];
    isVerified: true, // if !isVerified then 'Unverified'
    isActive: true, // if isVerified then 'Suspended' || 'Active'];
    verificationSentOn: '05/25/2020 4:50pm PST',
    lastActiveOn: '05/25/2020 4:50pm PST',
    teamsId: [0],
    teams: [{
      id: 0, name: 'Finance', color: '#8d6e92', icon: 'globe',
    }],
  }, {
    id: 2,
    firstName: 'Jessica',
    lastName: 'Evans',
    imageUrl: '',
    email: 'rabdallah@gmail.com',
    phone: '(123) 456-7890',
    userType: 0,
    isVerified: false,
    isActive: false,
    verificationSentOn: '05/26/2020 4:50pm PST',
    lastActiveOn: '',
    teamsId: [1, 2],
    teams: [
      {
        id: 1, name: 'Marketing', color: '#ee9183', icon: 'dollar-sign',
      }, {
        id: 2, name: 'Sales', color: '#d1aa53', icon: 'sack-dollar',
      },
    ],
  }, {
    id: 2,
    firstName: 'Delilah',
    lastName: 'Jones',
    imageUrl: '',
    email: 'djones@gmail.com',
    phone: '(098) 765-4321',
    userType: 0,
    isVerified: true,
    isActive: false,
    verificationSentOn: '05/27/2020 4:50pm PST',
    lastActiveOn: '05/27/2020 4:50pm PST',
    teamsId: [2],
    teams: [{
      id: 2, name: 'Sales', color: '#d1aa53', icon: 'sack-dollar',
    }],
  },
];

export const companies = [
  {
    id: 0,
    name: 'TopDevz',
    address: '123 Main Street',
    city: 'Berkeley',
    state: 'CA',
    zip: '99999',
    phone: '(123) 456-7890',
    email: 'sharoon@gmail.com',
  }, {
    id: 1,
    name: 'HubSuite',
    address: '456 5th Street',
    city: ' Des Moines',
    state: 'IA',
    zip: '99999',
    phone: '(098) 765-4321',
    email: 'brose@gmail.com',
  }, {
    id: 2,
    name: 'Appnexio',
    address: '237 Market Street ',
    city: 'San Francisco',
    state: 'CA',
    zip: '99999',
    phone: '(123) 456-7890',
    email: 'prose@gmail.com',
  },
];
export const types = [
  {
    id: 0, name: 'One-Time',
  }, {
    id: 1, name: 'Open',
  },
];

export const meetings = [
  {
    id: 0,
    title: 'Company Meeting',
    date: '08/20/2020',
    type: 'One Time',
    link: 'meet.connecthub.live/appnexio/company123',
    shortId: 'u4GZUaepP',
  }, {
    id: 1,
    title: 'Finance Meeting',
    date: '08/25/2020',
    type: 'Open',
    link: 'meet.connecthub.live/appnexio/finance123',
    shortId: 'pqcelkh1Q',
  }, {
    id: 2,
    title: 'Sales Meeting',
    date: '09/13/2020',
    type: 'One Time',
    link: 'meet.connecthub.live/appnexio/sales123',
    shortId: 'u4GZUaepP',
  },
  {
    id: 3,
    title: 'Marketing Meeting',
    date: '10/06/2020',
    type: 'Open',
    link: 'meet.connecthub.live/appnexio/marketing123',
    shortId: 'pqcelkh1Q',
  },
];
